import { render, staticRenderFns } from "./AccountPageBuilder.vue?vue&type=template&id=0c79de7d"
import script from "./AccountPageBuilder.vue?vue&type=script&lang=js"
export * from "./AccountPageBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports